import React, {h, Component} from 'preact';

export default class SellExpectedListDateStep extends Component {
    componentDidMount() {
        trackEvent('Flow', 'SellRequest', 'sellV3Step2')
            .withGA()
            .withOptimizely();

        trackEvent('Flow', 'SellRequest', 'sellerRequestStep2PageLoad', {
            abTestWHYVersion: window.abTestWHYVersion
        })
            .withGA()
            .withOptimizely();
    }

    chooseAnswer(date) {
        let currentStep ='SELL_PRICE_RANGE';
            // this.props.parent.addressDetails && this.props.parent.addressDetails.homeType
            //     ? 'SELL_PRICE_RANGE'
            //     : 'SELL_HOME_TYPE';

        this.props.parent.priceRangePromise.then(data => {
            if (data.redirectUrl) {
                window.location = data.redirectUrl;
                return;
            }
            this.props.parent.setState({
                expectedListDate: date,
                agentCount: data.agentCount,
                priceRanges: data.roundedPriceRanges,
                avgSavings: data.avgSavings,
                currentStep
            });
        });
    }

    render() {
        return (
            <div className="flow-step">
                <div className="flow-step-header-text">
                    <strong>How soon are you looking to sell?</strong>
                </div>

                <div className="option-div">
                    <div
                        onClick={() =>
                            this.chooseAnswer(
                                moment()
                                    .add(15, 'day')
                                    .toDate()
                                    .getTime()
                            )
                        }
                        className="choice-button agent-preference-button">
                        <img src={global.imageBaseUrl + 'buysell/svg/flash.svg'} />
                        <div style={{overflow: 'hidden'}}>
                            <span className="button-text">Right Away</span>
                        </div>
                    </div>
                    <div
                        onClick={() =>
                            this.chooseAnswer(
                                moment()
                                    .add(30, 'day')
                                    .toDate()
                                    .getTime()
                            )
                        }
                        className="choice-button agent-preference-button">
                        <img src={global.imageBaseUrl + 'buysell/svg/house-megaphone.svg'} />
                        <div style={{overflow: 'hidden'}}>
                            <span className="button-text">1-3 Months</span>
                        </div>
                    </div>
                    <div
                        onClick={() =>
                            this.chooseAnswer(
                                moment()
                                    .add(90, 'day')
                                    .toDate()
                                    .getTime()
                            )
                        }
                        className="choice-button agent-preference-button">
                        <img src={global.imageBaseUrl + 'buysell/svg/sell-outline.svg'} />
                        <div style={{overflow: 'hidden'}}>
                            <span className="button-text">4+ Months</span>
                        </div>
                    </div>
                    <div
                        onClick={() =>
                            this.chooseAnswer(
                                moment()
                                    .add(-15, 'day')
                                    .toDate()
                                    .getTime()
                            )
                        }
                        className="choice-button agent-preference-button">
                        <img src={global.imageBaseUrl + 'buysell/svg/whiteboard-arrow.svg'} />
                        <div style={{overflow: 'hidden'}}>
                            <span className="button-text">Already Listed</span>
                        </div>
                    </div>
                </div>

                <div className="flow-spacer" />

                <div className="bottom-banner" style={this.props.showAgentCount ? '' : 'display: none'}>
                    <div className="status-normal">
                        <div className="title">
                            <img src={global.imageBaseUrl + '/buysell/svg/top-agents.svg'} /> Top Performing Agents
                        </div>
                        <div className="subtitle subtitle-large">
                            {this.props.parent.state.agentCount} UpNest partner agents specialized in{' '}
                            {this.props.parent.state.priceRangeStr} price range.
                        </div>
                    </div>
                    <div className="status-normal subtitle subtitle-small">
                        {this.props.parent.state.agentCount} UpNest partner agents specialized in{' '}
                        {this.props.parent.state.priceRangeStr} price range.
                    </div>
                </div>
            </div>
        );
    }
}
